// Node
const $ = require('jquery');

$(function() {
  let $mapBlockLabel = $('.adv__item > a.adv__img_map');
  let $mapBlockLink = $mapBlockLabel.siblings('.adv__title').find('a');

  [$mapBlockLabel, $mapBlockLink].forEach((elem) => {
    $(elem).on('click', () => {
      window.ymReachGoal('main:camps-on-map');
    });
  });
});
